import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { useTranslation } from 'react-i18next';

interface Props {
    handleOnClose: () => void;
    handleOnAgree: () => void;
    open: boolean;
}

const BackToLibraryDialog: React.FC<Props> = (props) => {
    const { handleOnClose, handleOnAgree, open } = props;
    const { t } = useTranslation();
    return (
        <div>
            <Dialog
                open={open}
                onClose={handleOnClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t(
                            'Are you sure, that you want to go back to graphic library? There are some graphics, that are uploaded, but not submitted.'
                        )}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleOnClose}
                        variant="outlined"
                        color="primary"
                    >
                        {t('Go back')}
                    </Button>
                    <Button
                        onClick={handleOnAgree}
                        variant="outlined"
                        color="primary"
                        autoFocus
                    >
                        {t('Continue to graphic library')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default BackToLibraryDialog;
